(() => {
  if (window.__cartPrecheckoutGuardInstalled) return;
  window.__cartPrecheckoutGuardInstalled = true;

  let resubmitting = false;

  /**
   * @param {Event} event
   */
  async function guardCheckout(event) {
    if (resubmitting) return;

    const trigger =
      event instanceof SubmitEvent && event.submitter instanceof HTMLElement
        ? event.submitter
        : event.target instanceof Element
          ? event.target.closest('[data-precheckout-enabled="true"]')
          : null;

    if (!(trigger instanceof HTMLElement) || trigger.dataset.precheckoutEnabled !== 'true') return;

    const root = trigger.closest('cart-items-component');
    const component = root?.querySelector('cart-precheckout');
    if (!(component instanceof HTMLElement)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    await customElements.whenDefined('cart-precheckout');

    if (
      typeof component.validateBeforeCheckout === 'function' &&
      !component.validateBeforeCheckout()
    ) {
      return;
    }

    if (typeof component.updateCartAttributesBeforeCheckout === 'function') {
      const saved = await component.updateCartAttributesBeforeCheckout();
      if (saved === false) return;
    }

    const form =
      root?.querySelector('form.cart-form') ||
      (event.target instanceof HTMLFormElement ? event.target : null) ||
      (trigger instanceof HTMLButtonElement ? trigger.form : null);

    if (!(form instanceof HTMLFormElement)) return;

    resubmitting = true;
    try {
      if (trigger instanceof HTMLButtonElement && trigger.form === form) {
        form.requestSubmit(trigger);
      } else {
        const submitter = document.createElement('button');
        submitter.type = 'submit';
        submitter.name = 'checkout';
        submitter.hidden = true;
        form.appendChild(submitter);
        form.requestSubmit(submitter);
        setTimeout(() => submitter.remove(), 0);
      }
    } finally {
      setTimeout(() => {
        resubmitting = false;
      }, 0);
    }
  }

  document.addEventListener('click', guardCheckout, true);
  document.addEventListener('submit', guardCheckout, true);
})();
